export const PENDO_ENABLED =
  process.env["NEXT_PUBLIC_PENDO_ENABLED"] === "true";
